import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import SriLanka from './pages/SriLanka';
import TourPackages from './pages/TourPackages';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';
import AyurvedaPage from './pages/AyurvedaPage';
import DivingPage from './pages/DivingPage';
import ElephantRidePage from './pages/ElephantRidePage';
import FishingPage from './pages/FishingPage';
import BallooningPage from './pages/BallooningPage';
import JeepSafariPage from './pages/JeepSafariPage';
import WhiteWaterRaftingPage from './pages/WhiteWaterRaftingPage';
import RiverSafariPage from './pages/RiverSafariPage';
import SnorkelingPage from './pages/SnorkelingPage';
import TeaTastingPage from './pages/TeaTastingPage';
import TempleVisitPage from './pages/TempleVisitPage';
import WildlifeSafariPage from './pages/WildlifeSafariPage';
import WhatsApp from './components/WhatsApp';
import Facebook from './components/Facebook';
import Instagram from './components/Instagram';
import Gallery from './pages/Gallery';
import Events from './pages/Events';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Star Lanka Tours Sri Lanka - Discover Beruwala & Bentota"
                  description="Join Star Lanka Tours Sri Lanka for unforgettable journeys from Beruwala and Bentota — beaches, river safaris, wildlife, culture, and personalized Sri Lanka tours."
                  keywords="Star Lanka Tours, Star Lanka Tours Sri Lanka, Beruwala Tours, Bentota Tours, Sri Lanka Tours, Negombo Tours, Wildlife Safaris Sri Lanka, Beach Holidays Sri Lanka, River Safari Bentota"
                  url="https://starlankatours.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Star Lanka Tours Sri Lanka"
                  description="Meet Star Lanka Tours Sri Lanka — your trusted local tour operator offering authentic, personalized travel experiences from Beruwala, Bentota, and across the island."
                  keywords="Star Lanka Tours, About Star Lanka Tours, Sri Lanka Tour Operator, Beruwala Tours, Bentota Tours, Nethaj Tours"
                  url="https://starlankatours.com/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Star Lanka Tours Sri Lanka"
                  description="Discover the beauty of Sri Lanka with Star Lanka Tours — golden beaches of Beruwala & Bentota, wildlife safaris, ancient temples, and misty hill country."
                  keywords="Explore Sri Lanka, Star Lanka Tours, Beruwala Beach, Bentota River, Sri Lanka Travel, Nature Tours, Wildlife Safari"
                  url="https://starlankatours.com/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Star Lanka Tours Sri Lanka"
                  description="Explore our handpicked tour packages from Star Lanka Tours Sri Lanka — beach getaways, wildlife adventures, cultural journeys, and more."
                  keywords="Sri Lanka Tour Packages, Star Lanka Tours, Bentota Tours, Beruwala Tours, Wildlife Tours, Beach Holidays"
                  url="https://starlankatours.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Star Lanka Tours Sri Lanka"
                  description="See beautiful moments from Star Lanka Tours journeys — beaches of Beruwala & Bentota, wildlife, temples, and Sri Lanka’s magic captured."
                  keywords="Sri Lanka Photos, Star Lanka Tours Gallery, Beruwala Beach, Bentota River Safari, Travel Memories"
                  url="https://starlankatours.com/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/events"
            element={
              <>
                <SEO
                  title="Special Events - Star Lanka Tours Sri Lanka"
                  description="Experience Sri Lanka’s vibrant festivals and cultural events with Star Lanka Tours — from Kandy Perahera to local celebrations."
                  keywords="Sri Lanka Events, Star Lanka Tours, Cultural Festivals, Kandy Perahera, Local Experiences"
                  url="https://starlankatours.com/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things to Do - Star Lanka Tours Sri Lanka"
                  description="Discover exciting activities with Star Lanka Tours Sri Lanka — river safaris in Bentota, wildlife, diving, tea tasting, and more."
                  keywords="Things To Do Sri Lanka, Star Lanka Tours, Bentota River Safari, Beruwala Beach, Wildlife Safari, Adventure Activities"
                  url="https://starlankatours.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Star Lanka Tours Sri Lanka"
                  description="Book your perfect Sri Lanka tour easily with Star Lanka Tours. Custom trips, beach holidays, safaris — starting from Beruwala & Bentota."
                  keywords="Book Sri Lanka Tours, Star Lanka Tours Bookings, Bentota Tours, Beruwala Tours, Travel Reservations"
                  url="https://starlankatours.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Star Lanka Tours Sri Lanka"
                  description="Get in touch with Star Lanka Tours Sri Lanka for bookings, inquiries, or custom tours. Reach us via WhatsApp, email or phone."
                  keywords="Contact Star Lanka Tours, Sri Lanka Tour Contact, Beruwala Tours, Bentota Tours, Travel Inquiries"
                  url="https://starlankatours.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />

          {/* Things To Do Individual Pages */}
          <Route
            path="/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda & Wellness - Star Lanka Tours Sri Lanka"
                  description="Relax and heal with authentic Ayurveda treatments and wellness experiences arranged by Star Lanka Tours Sri Lanka."
                  keywords="Ayurveda Sri Lanka, Star Lanka Wellness, Bentota Ayurveda, Beruwala Wellness, Spa Packages"
                  url="https://starlankatours.com/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/diving"
            element={
              <>
                <SEO
                  title="Scuba Diving - Star Lanka Tours Sri Lanka"
                  description="Dive into Sri Lanka’s colorful underwater world with guided diving trips from Star Lanka Tours."
                  keywords="Diving Sri Lanka, Star Lanka Diving, Bentota Diving, Marine Adventures"
                  url="https://starlankatours.com/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Star Lanka Tours Sri Lanka"
                  description="Meet Sri Lanka’s gentle giants responsibly with Star Lanka Tours — ethical elephant interactions and safaris."
                  keywords="Elephant Safari Sri Lanka, Star Lanka Tours, Wildlife Experiences"
                  url="https://starlankatours.com/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Star Lanka Tours Sri Lanka"
                  description="Enjoy deep-sea and lagoon fishing adventures along Sri Lanka’s coast with Star Lanka Tours."
                  keywords="Fishing Sri Lanka, Star Lanka Tours, Beruwala Fishing, Bentota Fishing"
                  url="https://starlankatours.com/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Star Lanka Tours Sri Lanka"
                  description="Float above Sri Lanka’s stunning landscapes on a magical hot air balloon ride with Star Lanka Tours."
                  keywords="Hot Air Ballooning Sri Lanka, Star Lanka Adventure, Scenic Flights"
                  url="https://starlankatours.com/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Star Lanka Tours Sri Lanka"
                  description="Experience thrilling jeep safaris in Sri Lanka’s national parks with expert guides from Star Lanka Tours."
                  keywords="Jeep Safari Sri Lanka, Star Lanka Wildlife, Yala Safari, Udawalawe Safari"
                  url="https://starlankatours.com/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Star Lanka Tours Sri Lanka"
                  description="Feel the thrill of white water rafting in Kitulgala with safe, guided tours from Star Lanka Tours."
                  keywords="White Water Rafting Sri Lanka, Star Lanka Adventures, Kitulgala Rafting"
                  url="https://starlankatours.com/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Star Lanka Tours Sri Lanka"
                  description="Cruise the beautiful Bentota River on a relaxing safari with Star Lanka Tours Sri Lanka."
                  keywords="River Safari Bentota, Star Lanka Nature Tours, Bentota Boat Ride"
                  url="https://starlankatours.com/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling - Star Lanka Tours Sri Lanka"
                  description="Explore colorful coral reefs and tropical fish with snorkeling trips arranged by Star Lanka Tours."
                  keywords="Snorkeling Sri Lanka, Star Lanka Marine Tours, Beach Activities"
                  url="https://starlankatours.com/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/tea-tasting"
            element={
              <>
                <SEO
                  title="Ceylon Tea Tasting - Star Lanka Tours Sri Lanka"
                  description="Enjoy authentic Ceylon tea tasting and plantation visits with Star Lanka Tours."
                  keywords="Tea Tasting Sri Lanka, Star Lanka Tours, Ceylon Tea, Hill Country"
                  url="https://starlankatours.com/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Star Lanka Tours Sri Lanka"
                  description="Explore Sri Lanka’s sacred temples and ancient heritage with guided tours from Star Lanka Tours."
                  keywords="Temple Visit Sri Lanka, Star Lanka Tours, Cultural Experiences"
                  url="https://starlankatours.com/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Star Lanka Tours Sri Lanka"
                  description="Join unforgettable wildlife safaris in Sri Lanka’s national parks with Star Lanka Tours."
                  keywords="Wildlife Safari Sri Lanka, Star Lanka Tours, Yala National Park, Udawalawe Elephants"
                  url="https://starlankatours.com/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />
        </Routes>
      </main>

      <WhatsApp />
      <Facebook />
      <Instagram />
      <Footer />
    </Router>
  );
};

export default App;